import { default as StripExhibitionist } from './StripExhibitionistBox';
import { withFeatureBranch } from '@wix/da-shared-react/pkg/redux/flags';
import StripExhibitionist__premium_folders from '../StripExhibitionist__premium_folders';

export default withFeatureBranch({
  premium_folders: StripExhibitionist__premium_folders,
})(StripExhibitionist);
